import React from 'react';
import {Modal, View, TouchableOpacity, StyleSheet} from 'react-native';

export const PopoverLandscape = ({
   visible,
   anchorView,
   content,
   onclose,
   width,
   height,
}) => {
   // if (!visible) {
   //   return null;
   // }

   return (
      <Modal
         visible={visible}
         animationType="fade"
         transparent
         hardwareAccelerated>
         <TouchableOpacity
            onPress={onclose}
            style={{
               flex: 1,
               position: 'absolute',
               justifyContent: 'space-between',
            }}>
            <View
               style={{
                  flex: 1,
               }}>
               <View
                  style={{
                     top: anchorView.y,
                     left: anchorView.x,
                     width: width,
                     height: 252 + 100,
                  }}>
                  {content}
               </View>
            </View>
            <View style={{width: width, height: height - 252}} />
         </TouchableOpacity>
      </Modal>
   );
};
